import { Hero } from "../components/Hero";
import { Problem } from "../components/Problem";
import { Studio } from "../components/Studio";
import { Cywiz } from "../components/Cywiz";
import { Method } from "../components/Method";
import { Faq } from "../components/Faq";
import { Need } from "../components/Need";
import { Contact } from "../components/Contact";
import { useSeo } from "../lib/seo";
import { useLang } from "../lib/i18n";

/**
 * Page unique.
 *
 * Positionnement : Aëlvir est un STUDIO de création, et le site est la
 * porte d'entrée de Cywiz. Le parcours est donc :
 *
 *   Hero .......... punchline signée + Cywiz prêt
 *   Problem ....... grille problème → conséquence → réponse (01)
 *   Studio ........ ce que nous savons construire     (02)
 *   Cywiz ......... preuve + produit déployable       (03)
 *   Method ........ quatre étapes                     (04)
 *   Faq ........... objections                        (05)
 *   Need .......... pont vers le projet
 *   Contact ....... devis                             (06)
 *
 * Ne pas réordonner sans revoir la numérotation des filigranes.
 */
export default function Home() {
  const { t } = useLang();
  useSeo({ path: "/", title: t.seo.title, description: t.seo.description });

  return (
    <>
      <Hero />
      <Problem />
      <Studio />
      <Cywiz />
      <Method />
      <Faq />
      <Need />
      <Contact />
    </>
  );
}
